export const UPDATE_CATEGORY='UPDATE_CATEGORY'
export const UPDATE_CATEGORY_SUCCESS= 'UPDATE_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_ERROR= 'UPDATE_CATEGORY_ERROR'

export const UpdateCategory= (data) => ({
    type: UPDATE_CATEGORY,
    payload: data
})

